import type React from 'react';

interface MenuIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const MenuIcon: React.FC<MenuIconProps> = ({ width = 20, height = 20, color = '#656565' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden="true"
    >
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
    </svg>
);

export default MenuIcon;
